import { useEffect } from "react";
import "./App.css";
import { initPotreeViewer } from "./common/potreeUtils";
import UploadData from "./components/upload/UploadData";
import Menubar from "./components/menubar/Menubar";
import DataManager from "./components/dataManager/DataManager";
import UserManager from "./components/userManager/UserManager";
import { useSnapshot } from "valtio";
import { Store } from "./store/Store";
import { Spin, message } from "antd";
import {  getIdToken } from "./components/userManager/userManagementUtils";
import Header from "./components/header/Header";
import { Route, Routes } from "react-router-dom";
import PaymentManager from "./components/tables/user/paymentManager/PaymentManager";
import { DownloadsTable } from "./components/tables/downloads/DownloadsTable";
import { QuotaTable } from "./components/tables/user/QuotaTable";
import TransactionDetails from "./components/tables/user/transaction/TransactionDetails";
import CrsInfo from "./components/infobar/CrsInfo";
import SupportManager from "./components/tables/user/supportManager/SupportManager";
import ShareDataModal from "./components/tables/user/share/ShareDataModal";

window.volumeForExport = null;

function App() {
    const snapShot = useSnapshot(Store);
    window.measures = {};
    
    useEffect(() => {
        if (snapShot.isLoggedIn) {
            const region = "us-west-1";
            getIdToken().then(() => {
                initPotreeViewer();
                Store.isInitialized = true;
            }).catch(() => {
                message.error("Something went wrong")
            })
        }
    }, [snapShot.isLoggedIn]);
    return (
        <>
            {snapShot.isLoggedIn === true ? (
                <>
                    <Header />
                    <Menubar />
                    <UploadData />
                    <CrsInfo />
                    <DataManager />
                    <Routes>
                        <Route path="/billing" element={<PaymentManager /> } />
                        <Route path="/downloads" element={<DownloadsTable /> } />
                        <Route path="/quotas" element={<QuotaTable /> } />
                        <Route path="/transactions" element={<TransactionDetails /> } />
                        <Route path="/support" element={<SupportManager /> } />
                    </Routes>
                </>
            ) : (
                <UserManager />
            )}

            {!snapShot.isInitialized ? (
                <div className="loader__block">
                    <Spin className="spin__loader" tip="Loading" size="large"></Spin>
                </div>
            ) : null}
        </>
    );
}

export default App;
